import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export const availableIcons = [
  'arrow-down',
  'arrow-up',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chevron-down',
  'clock',
  'close',
  'info',
  'minus',
  'plus',
  'checked',
  'checked-circle',
  'bag',
  'bag-outline',
  'edit',
  'calendar-check',
  'star',
  'star-filled',
  'star-half-filled',
  'low-price-promise',
  'smart-pass',
  'offer',
  'coupon',
  'regulars',
  'age-restriction',
  'question-mark',
  'expiry-date',
  'heart-filled',
  'heart-empty',
  'add-to-shopping-list',
  'value-delivered',
];

export default class Icon extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.oneOf(availableIcons).isRequired,
  };

  render() {
    const { className, name } = this.props;
    return (
      <span className={`icon icon__${name} ${className || ''}`} />
    );
  }
}
